const strategy= {
  state: {
    listData: [
                {"marqueeId":1,"list":["带权重的随机策略","成本优先策略","灾备策略"],"title":"策略1","createTime":"2024-07-10 17:26:29"},
                {"marqueeId":2,"list":["会话黏连策略","通话质量优先策略","地域映射策略"],"title":"策略2","createTime":"2024-10-10 17:26:29"}
                ]
  },
  mutations: {
    ADD_ITEM:(state,item)=>{
      state.listData.push(item);
    },
    DEL_ITEM:(state,marqueeId)=>{
       state.listData = state.listData.filter(item => item.marqueeId !== marqueeId);
    },
    EDIT_ITEM:(state,info)=>{
                         state.listData = state.listData.map(item => {
                                        if (item.marqueeId === info.marqueeId) {

                                          return { ...info };  // 返回新的对象
                                        }
                                        return item;  // 返回原始对象
                         });
        },
  },
  actions: {
    addItem({ commit }, item) {
      commit("ADD_ITEM", item);
    },
    editItem({ commit }, item) {
          commit("EDIT_ITEM", item);
        },
    delItem({ commit }, marqueeId) {
      commit("DEL_ITEM", marqueeId);
    },
  }
};
export default strategy;